<app-adloop-card [class]="'display-block full-height ' + backgroundImgClass">
  <small class="mb-10 display-block">{{ 'loginPage.enter_your_email' | translate }}</small>
  <app-form-builder
    [form]="form"
    [formDef]="formDef"
    [errors]="errors"
    (onSubmit)="submit($event)"></app-form-builder>
</app-adloop-card>
